import { useThemeState } from "./useThemeState.mjs";
const forceUpdateState = {
    forceClassName: !0,
    deopt: !0,
    needsUpdate: () => !0
  },
  forceKeys = {
    current: /* @__PURE__ */new Set([""])
  };
function useThemeName() {
  return useThemeState(forceUpdateState, !1, forceKeys)?.name || "";
}
export { useThemeName };
//# sourceMappingURL=useThemeName.mjs.map
